<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

  <div class="container3" style="margin-top:60px">
    <div class="row" *ngIf="otpconfirm === 0">
      <div class="col-12">
        <div class="card" style="padding:5px">
            <form (ngSubmit)="postForAdoption(f)" #f="ngForm"  enctype="multipart/form-data">
              <div class="form-group">
              <label for="name"> Pet Name</label>
              <input type="text" name="petname" id="petname" ngModel class="form-control" required>
              </div>
              <div class="form-group">
                  <label for="name">Description</label>
                  <textarea class="form-control" rows="6" name="petdesc" id="petdesc" ngModel class="form-control" required></textarea>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <div class="form-group" >
                            <label>Pet Type</label>
                            <select   name="ptype" id="ptype"  [(ngModel)]="selected_pet_type" class="form-control" required>
                              <option *ngFor="let data of pettype" value="{{data.id}}">{{data.name}}</option>
                              </select>
                            </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <div class="form-group" *ngIf="!(selected_pet_type == undefined)">
                            <label>Breed</label>
                            <select name="btype" id="btype" [(ngModel)]="selected_breed"  class="form-control" required>
                              <option *ngFor="let data of breed | dynamicbreed: selected_pet_type" value={{data.id}}>{{data.name}}</option>
                            </select>
                            </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                          <div class="form-group">
                              <label>Gender</label>
                              <select type="text" name="gender" id="gender"  ngModel class="form-control" required>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                              </select>
                              </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                          <div class="form-group">
                              <label>Age</label>
                              <select type="text" name="age" id="age"  ngModel class="form-control" required>
                                <option *ngFor="let data of age" value="{{data}}">{{data}}</option>
                                </select>
                              </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">

                            <div class="form-group">
                                <label >Color</label>
                                <select type="text" name="color" id="color"  ngModel class="form-control" required>
                                    <option *ngFor="let data of color" value="{{data}}">{{data}}</option>
                                    </select>
                              </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group">
                                <label>City</label>
                                <select type="text" name="city" id="city"  [(ngModel)]="selectedcity" class="form-control" required>
                                  <option *ngFor="let data of city" value="{{data.id}}">{{data.location}}</option>
                                  </select>
                                </div>
                          </div>
                      </div>

                  <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <div class="form-group" *ngIf="selectedcity">
                            <label>Location</label>
                            <select type="text" name="location" id="location"  ngModel class="form-control" required>
                              <option *ngFor="let data of location | dinamiccity: selectedcity" value="{{data.id}}">{{data.location}}</option>
                              </select>
                            </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">

                  <div class="form-group" >
                      <label>Neutered / Spayed? </label>
                      <select type="text" name="q1" id="q1"  ngModel class="form-control" required>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                        </select>
                      </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">

                          <div class="form-group" >
                              <label>Have Vaccination Details / Health Records </label>
                              <select type="text" name="q2" id="q2"  ngModel class="form-control" required>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                                </select>
                              </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                          <div class="form-group" >
                              <label>Have KCI Certification?	 </label>
                              <select type="text" name="q3" id="q3"  ngModel class="form-control" required>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                                </select>
                              </div>
                        </div>
                    </div>

          <div class="form-group">
              <label for="postimage">Please Add One Image</label>
                <input type="file" name="photo" ngFileSelect [options]="options" (onUpload)="handleUpload($event)" (beforeUpload)="beforeUpload($event)" ngModel class="form-control" required>
          </div>
          <div class="row" style="margin-top:2%; margin-bottom:4%">
            <div class=" col-sm-4 col-md-6 col-lg-6 col-xl-6">
                <button type="submit" class="btn btn-success3 btn-block" [disabled]="!f.valid">Upload Your Post</button>
            </div>
            <div class=" col-sm-4 col-md-6 col-lg-6 col-xl-6">
                <button class="btn btn-success btn-block" routerLink="/petadoption/home">Cancel</button>
              </div>
          </div>
              </form>
        </div>
      </div>
    </div>
    <div class="card" *ngIf="otpconfirm === 1" style="margin:5%">
      <div class="row">
        <div class="col">
          <p style="color: red; font-style: open sans ; font-size: 25px">
            Your Mobile Number Is Not Verified With us.
            so Please Verify your mobile Number..
          </p>
          <p style=" font-style: open sans ; font-size: 25px">Your Contact  {{usermobile}}</p>
          <a style="cursor : pointer" (click)="genOtp()"><strong> here to Verify Your Mobile</strong></a>
        </div>
      </div>
    </div>
    <div class="card" *ngIf="otpconfirm === 2" style="margin:5%">
      <div class="card-header">
        <h4 style="font-style: open sans; color:#9b7544">Otp verification</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 text-center">
            <label style="color:#9b7544; font-style: open sans">
              <span><strong>Otp has Been Sent to Your Registered Mobile Number</strong></span>
            </label>
          </div>
        </div>
        <form (ngSubmit)="postForOtp(f1)" #f1="ngForm">
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <div class="form-group">
                  <label for="name"> Enter Otp Here</label>
                  <input type="text" name="otp" id="otp" ngModel class="form-control" required>
                  </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <button type="submit" class="btn btn-success btn-block" [disabled]="!f1.valid">Confirm Otp</button>
            </div>
        </div>
      </form>
      </div>
    </div>
    <div class="row"  *ngIf="otpconfirm === 3 &&  documentuploadflag == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-12 text-center">
                <h4 style="font-family: open sans; color:#9b7544"><strong>Update Documents</strong></h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row" style="margin:1%" *ngIf="uploadingflag == 0">
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <button class="btn btn-success btn-block"  *ngIf= "AdoptionDocument &&
                AdoptionDocument.length === 0"  (click)="addDocument()">Upload  Document</button>
                <button class="btn btn-secondary btn-block"  *ngIf= "AdoptionDocument &&
                AdoptionDocument.length > 0"  (click)="addDocument()">Upload Another Document</button>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <button class="btn btn-success3 btn-block"  (click)="showFinalmessage()">Complete post</button>
                </div>

            </div>
            <div class="row" style="margin:1%"  *ngIf= "uploadingflag == 0
            && AdoptionDocument && AdoptionDocument.length> 0">
            <div class="col-12" *ngFor="let doc of AdoptionDocument">
              <div class="row">
                  <div class="col-4">
                      Doc Type: {{doc.document_type}}
                    </div>
                    <div class="col-4">
                      File Name: {{doc.path}}
                      </div>
                      <div class="col-4" style="color:#9b7544">
                         <mat-icon>done all</mat-icon> Uploaded
                        </div>
              </div>

            </div>
              </div>
            <div class="row"  *ngIf="uploadingflag == 1">
              <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 text-center">
                  <div class="form-group" >
                      <label>Document Type</label>
                      <select type="text" name="doc" id="doc"  [(ngModel)]="doctype" class="form-control">
                        <option value="kci">kci</option>
                        <option value="health">Health Record</option>
                        </select>
                      </div>
              </div>
              <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 text-center" style="margin:2%" *ngIf="doctype" >
                  <div class="form-group">
                        <input type="file" name="photo" ngFileSelect [options]="options" (onUpload)="handleUploaddoc($event)" (beforeUpload)="beforeUploaddoc($event)"  ngModel class="form-control" required>
                  </div>
              </div>
              <div class="col-12 text-right" style="margin-bottom:2px">
                <button class="btn btn-secondary" *ngIf="filename && doctype" (click)="setAdoptionDocumentpath()">Upload</button>
              </div>
            </div>

            <div class="row" style="margin-top:2%" *ngIf="uploadingflag == 2">
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <label style="font-style: open sans; color:#9b7544; font-size:22px">
                  <span><strong>Upload Successful</strong></span>
                </label>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <button class="btn btn-secondary btn-block" (click)="CancelUpload()">Ok</button>
                </div>
            </div>
          </div>
          <div class="card-footer"  *ngIf="uploadingflag == 1">
              <div class="row" >
                  <div class="col-12 text-center" style="margin:1%">
                    <button class="btn btn-success btn-block" (click)="CancelUpload()">cancel upload</button>
                  </div>
                  </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row"  *ngIf="otpconfirm === 3 &&  documentuploadflag == 0" style="margin-top:2%">
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:2%">
          <label style="font-family: open sans; color: #9b7544; font-size:22px;overflow-wrap: break-word">
            <span><strong>Your Adoption Detail Has Been Uploaded Successfully.It will published after verification
              .Our team member will Verify this post with in 24 hours
              </strong></span>
          </label>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" >
          <button class="btn btn-success3 btn-block" routerLink="/petadoption/home">Ok</button>
        </div>
      </div>
      <div class="row" *ngIf="otpconfirm === 4" style="margin-top:2%">
          <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:2%">
              <label style="font-family: open sans; color: #9b7544; font-size:22px;overflow-wrap: break-word">
                <span><strong>Your Adoption Detail Has Been Uploaded Successfully.  ** This Post wll be published after verification.
                  Verificaion is expected to be complete with in 24 hours
                  </strong></span>
              </label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" >
              <button class="btn btn-success2 btn-block" routerLink="/petadoption/home">Ok</button>
            </div>
      </div>
  </div>
